import { Space } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import {
  type AddressLinkValues,
  type AddressQuickLink,
  buildAddressQuickLinks
} from "./address-quick-links.ts"

interface AddressQuickLinksProps extends AddressLinkValues {
  className?: string
}

function AddressQuickLinks({ className, ...address }: AddressQuickLinksProps) {
  const { t } = useTranslation()
  const links = buildAddressQuickLinks(address)
  if (!links.length) return null

  const copy: Record<
    AddressQuickLink["id"],
    { label: string; ariaLabel: string }
  > = {
    maps: {
      label: t("addressQuickLinks.maps.label"),
      ariaLabel: t("addressQuickLinks.maps.ariaLabel")
    },
    satellite: {
      label: t("addressQuickLinks.satellite.label"),
      ariaLabel: t("addressQuickLinks.satellite.ariaLabel")
    },
    zillow: {
      label: t("addressQuickLinks.zillow.label"),
      ariaLabel: t("addressQuickLinks.zillow.ariaLabel")
    }
  }

  return (
    <nav
      aria-label={t("addressQuickLinks.navigationLabel")}
      className={className}
    >
      <Space size="small" wrap>
        {links.map((link) => {
          const text = copy[link.id]

          return (
            <a
              key={link.id}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={text.ariaLabel}
              className="text-primary hover:underline"
            >
              {text.label}
            </a>
          )
        })}
      </Space>
    </nav>
  )
}

export { AddressQuickLinks }
